import Link from 'next/link';
import styled from 'styled-components';
import { Trans } from 'react-i18next';
import { t } from 'localization/utils/t';

const TP = 'error.components.DefaultError';

export const DefaultError = () => (
  <DefaultError.Wrapper>
    <p>{t(`${TP}.title`, 'Sorry, something went wrong.')}</p>
    <p>
      <Trans
        i18nKey={`${TP}.body`}
        defaults="Please, contact <0>Support</0>."
        components={[<Link href="https://goat.zendesk.com/hc/en-us" legacyBehavior />]}
      />
    </p>
  </DefaultError.Wrapper>
);

DefaultError.Wrapper = styled.div`
  text-align: center;
`;
